(function () {
  function initRadioPlaylist() {
    if (window.TR_RADIO_BOOTSTRAPPED) {
      bindRadioControls();

      if (window.Player && typeof window.Player.getState === 'function') {
        renderRadioState(window.Player.getState());
      }

      return;
    }

    if (typeof window.Player === 'undefined') {
      console.warn('TR Radio: Player is not loaded.');
      return;
    }

    if (!window.TR_PLAYLISTS || !window.TR_PLAYLISTS.length) {
      console.warn('TR Radio: TR_PLAYLISTS is empty or missing.');
      return;
    }

    if (!window.TR_PLAYLISTS[0].tracks || !window.TR_PLAYLISTS[0].tracks.length) {
      console.warn('TR Radio: playlist has no tracks.', window.TR_PLAYLISTS);
      return;
    }

    window.Player.init(window.TR_PLAYLISTS);
    window.Player.volume(0.7);
    window.TR_RADIO_BOOTSTRAPPED = true;

    console.log('TR Radio bootstrapped:', window.TR_PLAYLISTS[0].tracks.length, 'tracks');

    bindRadioControls();
    renderRadioState(window.Player.getState());

    // WordPress-style autoplay attempt.
    window.setTimeout(function () {
      var state = window.Player.getState();

      if (!state.playing) {
        console.log('TR Radio attempting autoplay');
        window.Player.play(0, 0);
      }
    }, 300);

    // Fallback: if browser blocks autoplay, first interaction starts it.
    bindFirstGestureAutoplay();
  }

  function bindRadioControls() {
    var playBtn = document.getElementById('music-player-btn-play');
    var prevBtn = document.getElementById('music-player-btn-prev');
    var nextBtn = document.getElementById('music-player-btn-next');
    var volumeSlider = document.getElementById('music-player-volume-slider');
    var infoBtn = document.getElementById('music-player-info');
    var player = document.getElementById('music-player');
    var queue = document.getElementById('music-player-queue');
    var volumeBtn = document.getElementById('music-player-volume-btn');
    var volumePanel = document.getElementById('music-player-volume-panel');

    if (!window.Player) {
      return;
    }

    if (playBtn && !playBtn.dataset.trBound) {
      playBtn.dataset.trBound = 'true';

      playBtn.addEventListener('click', function () {
        console.log('TR Radio play button clicked');
        window.Player.toggle();
      });
    }

    if (prevBtn && !prevBtn.dataset.trBound) {
      prevBtn.dataset.trBound = 'true';

      prevBtn.addEventListener('click', function () {
        window.Player.prev();
      });
    }

    if (nextBtn && !nextBtn.dataset.trBound) {
      nextBtn.dataset.trBound = 'true';

      nextBtn.addEventListener('click', function () {
        window.Player.next();
      });
    }

    if (volumeSlider && !volumeSlider.dataset.trBound) {
      volumeSlider.dataset.trBound = 'true';

      volumeSlider.addEventListener('input', function (event) {
        window.Player.volume(Number(event.target.value));
      });
    }

    if (infoBtn && player && queue && !infoBtn.dataset.trQueueBound) {
      infoBtn.dataset.trQueueBound = 'true';

      infoBtn.addEventListener('click', function (event) {
        event.preventDefault();

        var isOpen = player.classList.toggle('music-player--queue-open');

        queue.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        infoBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (isOpen) {
          renderQueue();
        }
      });
    }

    if (volumeBtn && player && volumePanel && !volumeBtn.dataset.trVolumeBound) {
      volumeBtn.dataset.trVolumeBound = 'true';

      volumeBtn.addEventListener('click', function (event) {
        event.preventDefault();

        var isOpen = player.classList.toggle('music-player--volume-open');

        volumePanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        volumeBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    if (!window.TR_RADIO_OUTSIDE_CLICK_BOUND) {
      window.TR_RADIO_OUTSIDE_CLICK_BOUND = true;

      document.addEventListener('click', function (event) {
        var currentPlayer = document.getElementById('music-player');

        if (!currentPlayer) {
          return;
        }

        if (event.target.closest('#music-player')) {
          return;
        }

        closeQueue();
        closeVolume();
      });
    }

    if (!window.TR_RADIO_PLAYER_CHANGE_BOUND) {
      window.TR_RADIO_PLAYER_CHANGE_BOUND = true;

      window.Player.on('change', function (state) {
        renderRadioState(state);
      });
    }
  }

  function bindFirstGestureAutoplay() {
    if (window.TR_RADIO_GESTURE_BOUND) {
      return;
    }

    window.TR_RADIO_GESTURE_BOUND = true;

    function startAfterGesture() {
      var state = window.Player.getState();

      if (!state.playing) {
        console.log('TR Radio starting after first gesture');
        window.Player.play(0, 0);
      }

      document.removeEventListener('click', startAfterGesture);
      document.removeEventListener('touchstart', startAfterGesture);
      document.removeEventListener('pointerdown', startAfterGesture);
      document.removeEventListener('keydown', startAfterGesture);
    }

    document.addEventListener('click', startAfterGesture);
    document.addEventListener('touchstart', startAfterGesture);
    document.addEventListener('pointerdown', startAfterGesture);
    document.addEventListener('keydown', startAfterGesture);
  }

  function renderQueue() {
    var queueList = document.getElementById('music-player-queue-list');

    if (!queueList || !window.Player || typeof window.Player.getState !== 'function') {
      return;
    }

    var state = window.Player.getState();

    if (!state.playlist || !state.playlist.tracks || !state.playlist.tracks.length) {
      queueList.innerHTML = '';
      return;
    }

    queueList.innerHTML = state.playlist.tracks.map(function (track, index) {
      var isCurrent = index === state.trackIndex;
      var isPlayed = index < state.trackIndex;
      var title = track.title || 'Untitled Track';
      var artist = track.artist || '';
      var label = artist ? title + ' — ' + artist : title;

      return '' +
        '<li class="music-player__queue-item' +
          (isCurrent ? ' music-player__queue-item--current' : '') +
          (isPlayed ? ' music-player__queue-item--played' : '') +
        '" data-track-index="' + index + '" role="option" tabindex="0" aria-selected="' + isCurrent + '">' +
          '<span class="music-player__queue-item-number">' + String(index + 1).padStart(2, '0') + '</span>' +
          '<span class="music-player__queue-item-title">' + escapeHTML(label) + '</span>' +
        '</li>';
    }).join('');

    queueList.querySelectorAll('[data-track-index]').forEach(function (item) {
      item.addEventListener('click', function () {
        var index = Number(item.dataset.trackIndex);

        window.Player.play(0, index);
        closeQueue();
      });

      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();

        var index = Number(item.dataset.trackIndex);

        window.Player.play(0, index);
        closeQueue();
      });
    });
  }

  function renderRadioState(state) {
    var title = document.getElementById('music-player-title');
    var playBtn = document.getElementById('music-player-btn-play');
    var live = document.getElementById('music-player-live');
    var player = document.getElementById('music-player');
    var volumeSlider = document.getElementById('music-player-volume-slider');

    state = state || {};

    if (title) {
      var album = state.track && state.track.album ? state.track.album : '';
      var song = state.track && state.track.title ? state.track.title : '';
      var artist = state.track && state.track.artist ? state.track.artist : '';

      if (song && artist) {
        title.textContent = song + ' — ' + artist;
      } else if (album && song) {
        title.textContent = song + ' - ' + album;
      } else {
        title.textContent = song || '—';
      }
    }

    if (playBtn) {
      playBtn.classList.toggle('is-playing', !!state.playing);
      playBtn.setAttribute('aria-label', state.playing ? 'Pause' : 'Play');
    }

    if (live) {
      live.classList.toggle('music-player__live--active', !!state.playing);
    }

    if (player) {
      player.classList.toggle('music-player--playing', !!state.playing);
    }

    if (volumeSlider && typeof state.volume !== 'undefined') {
      volumeSlider.value = state.volume;
    }

    if (player && player.classList.contains('music-player--queue-open')) {
      renderQueue();
    }
  }

  function closeQueue() {
    var player = document.getElementById('music-player');
    var queue = document.getElementById('music-player-queue');
    var infoBtn = document.getElementById('music-player-info');

    if (player) {
      player.classList.remove('music-player--queue-open');
    }

    if (queue) {
      queue.setAttribute('aria-hidden', 'true');
    }

    if (infoBtn) {
      infoBtn.setAttribute('aria-expanded', 'false');
    }
  }

  function closeVolume() {
    var player = document.getElementById('music-player');
    var volumePanel = document.getElementById('music-player-volume-panel');
    var volumeBtn = document.getElementById('music-player-volume-btn');

    if (player) {
      player.classList.remove('music-player--volume-open');
    }

    if (volumePanel) {
      volumePanel.setAttribute('aria-hidden', 'true');
    }

    if (volumeBtn) {
      volumeBtn.setAttribute('aria-expanded', 'false');
    }
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRadioPlaylist);
  } else {
    initRadioPlaylist();
  }

  document.addEventListener('turbo:load', function () {
    initRadioPlaylist();

    if (window.Player && typeof window.Player.getState === 'function') {
      renderRadioState(window.Player.getState());
    }
  });
})();